import { render, staticRenderFns } from "./OperationSuccessful.vue?vue&type=template&id=1c81e656&scoped=true&"
import script from "./OperationSuccessful.vue?vue&type=script&lang=js&"
export * from "./OperationSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./OperationSuccessful.vue?vue&type=style&index=0&id=1c81e656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81e656",
  null
  
)

export default component.exports